export const transformFootnote = (footnote: HTMLElement) => {
  const cuiFootnote = document.createElement("cui-footnote");
  const footnoteId = Number(footnote.dataset.footnoteId);
  cuiFootnote.setAttribute("ids", JSON.stringify([footnoteId]));
  footnote.insertAdjacentElement("beforebegin", cuiFootnote);
  footnote.remove();
};
